import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { VisitorQueriesManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/visitor-queries")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <VisitorQueriesManagement />
    </RouteGuard>
  ),
});
